import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const StatusServiceConfig = {
  name: "Status",
  annotations: []
} as ServiceConfig;